export class StorageError extends Error {
    providerId;
    op;
    cause;
    constructor(message, providerId, op, cause) {
        super(message);
        this.providerId = providerId;
        this.op = op;
        this.cause = cause;
        this.name = 'StorageError';
    }
}
export class StorageAuthError extends StorageError {
    constructor(providerId, op, cause) {
        super(`Auth failed for provider ${providerId} during ${op}`, providerId, op, cause);
        this.name = 'StorageAuthError';
    }
}
export class StorageQuotaError extends StorageError {
    constructor(providerId, op, cause) {
        super(`Quota exceeded for provider ${providerId} during ${op}`, providerId, op, cause);
        this.name = 'StorageQuotaError';
    }
}
export class StorageNotFoundError extends StorageError {
    constructor(providerId, op, cause) {
        super(`Not found in provider ${providerId} during ${op}`, providerId, op, cause);
        this.name = 'StorageNotFoundError';
    }
}
//# sourceMappingURL=errors.js.map